export default __webpack_public_path__ + "static/media/icon_login2.628452b6.png";